import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { useProfile } from "../../../hook/useProfile";
import toast from "react-hot-toast";

interface ProfileDrawerProps {
  userName?: string;
  user?: { isLoading: boolean };
  toggleProfileDrawer: () => void;
  handleLogout: () => void;
  logout: { isPending: boolean };
}

const ProfileDrawer: React.FC<ProfileDrawerProps> = ({
  userName,
  user,
  toggleProfileDrawer,
  handleLogout,
  logout,
}) => {
  const {Profile,addProfile} = useProfile()
  const userId = localStorage.getItem("R_M_uid");

  const data  =  Profile(userId)


  // console.log(data)

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
      
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload!");
      return;
    }
    setIsUploading(true);
 
    try {
      await addProfile.mutateAsync({
        userId: userId,
        file: selectedFile
      })
      toast.success("File uploaded successfully!");
    } catch (error) {
      console.error("Error during file upload:", error);
      toast.error("An error occurred while uploading the file. Please try again.");
    } finally {
      setSelectedFile(null)
      setIsUploading(false);
    }
  };
  

  return (
    <div className="fixed inset-0 z-40 flex justify-end transition-all duration-500 bg-black bg-opacity-50">
      <div className="w-80 bg-white h-full shadow-lg">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <span className="text-xl font-bold">Profile</span>
          <button onClick={toggleProfileDrawer}>
            <AiOutlineClose className="h-6 w-6 text-gray-800" />
          </button>
        </div>

        {/* Profile Section */}
        <div className="p-6 flex flex-col items-center gap-4 border ">
          <div className="relative">
            {/* Profile Picture */}
            <img
              className="w-28 h-28 object-cover object-center border-4 border-primary rounded-full"
              src={data.data==undefined?`https://via.placeholder.com/200x200.png?text=${
                user?.isLoading || userName === undefined
                  ? "."
                  : userName.charAt(0).toUpperCase()
              }`:`data:image/png;base64,${(data as any).data.data}`}
              alt="Profile"
            />
            {/* Edit Icon */}
            <label
              htmlFor="fileInput"
              className="absolute bottom-2 right-2 bg-primary text-white p-2 rounded-full cursor-pointer"
            >
              <FiEdit />
            </label>
            <input
              id="fileInput"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
          </div>
          <p className="text-xl font-semibold">
            {user?.isLoading ? "Loading..." : userName || "Guest"}
          </p>
          {selectedFile && (
            <p className="text-sm text-gray-600">
              Selected file: <strong>{selectedFile.name}</strong>
            </p>
          )}
          <button
            onClick={handleUpload}
            disabled={isUploading}
            className={`px-4 py-2 rounded-lg text-white hover:text-primary border hover:border-primary w-full ${
              isUploading
                ? "bg-primary/10 border-primary cursor-not-allowed"
                : "bg-primary hover:bg-primary/10  "
            }`}
          >
            {isUploading ? (
              <div className="flex text-primary items-center justify-center">
                <FaSpinner className="animate-spin mr-2" />
                Uploading...
              </div>
            ) : (
              "Upload Profile Picture"
            )}
          </button>
        </div>

        {/* Action Section */}
        <div className="p-4">
          <ul className="space-y-2">
           
            <li
              onClick={handleLogout}
              className="p-2 text-red-500 border border-red-400 rounded-lg cursor-pointer bg-red-50 hover:bg-red-100 flex items-center justify-center"
            >
              {logout.isPending ? (
                <div className="flex gap-2 items-center">
                  <FaSpinner className="animate-spin" /> Logging out...
                </div>
              ) : (
                "Logout"
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfileDrawer;
